<template>
  <v-card v-if="loaded()">
    <v-card-title class="headline">Delete Confirmation</v-card-title>
    <v-card-text>
      Are you sure you want to delete
      <span v-if="record.name">{{ entityType }}: {{ record.name }}?</span>
      <span v-else>{{ entityType }}?</span>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn outlined @click="cancel" class="mr-2">Cancel</v-btn>
      <v-btn color="warning elevation-0 font-weight-bold" @click="submit"
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  computed: {
    record() {
      return this.$store.state[this.entityType].record;
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit("setDialog", false);
    },
    loaded() {
      return this.record;
    },
    async submit() {
      try {
        await this.$store.dispatch(`${this.entityType}/remove`, this.entityId);
        this.$emit("setDialog", false);
      } catch (e) {
        // eslint-disable-next-line
        console.error(e);
        if (e.message === "Request failed with status code 409") {
          return this.$notifyError({
            message: `Could not delete ${
              this.entityType
            }. ${this.entityType[0].toUpperCase()}${this.entityType.slice(
              1
            )} in use.`,
          });
        }
        this.$notifyError({
          message: `Could not delete ${this.entityType}.`,
        });
      }
    },
  },
  props: ["entityType", "entityId"],
};
</script>
